export class Article_TypeAPIModel {
  GetTypeColumn: string = "";
  GetArticleTypeById: string = "";
  AddUpdateArticleType: string = "";
  DeleteArticleType: string = "";
}
